import axios from "axios";

const apiExterior = axios.create({
  baseURL: process.env.REACT_APP_WLBE_XP_EXTERIOR || "http://localhost:8889",
  headers: {
    "x-api-provider": "exterior-xpinvestimentos",
  },
});

export default apiExterior;
